import Vue from 'vue'

import DatePickeNew from '@/components/elementUiCustom/date-picker-new/index'
import DatePicker from '@/components/elementUiCustom/date-picker/index'
import Dialog from '@/components/elementUiCustom/dialog/index'
import Input from '@/components/elementUiCustom/input/index'
import Loading from '@/components/elementUiCustom/loading/index'
// @ts-ignore
import VueTheMask from 'vue-the-mask'

Input.install(Vue)
Loading.install(Vue)
Dialog.install(Vue)
// @ts-ignore
DatePicker.install(Vue)
// @ts-ignore
DatePickeNew.install(Vue)
Vue.use(VueTheMask)
